// Make print button
const printButton = document.getElementById('printButton')
if (printButton) {
  printButton.addEventListener('click', function() {
    window.print()
  })
}
